import request from "../../utils/request";
import { Result } from "../../models/general";

export interface EmployeeHierarchyView {
    id: string;
    name: string;
    title: string;
    department: string;
    imageUrl?: string;
    email: string;
    phoneNumber?: string;
    directReportIds: string[];
    managerId?: string;
    isManager: boolean;
    employeeCount: number;
    /**
     * Exit-date lifecycle (docs/exit-date-lifecycle-spec.md §3.5). Only "Active" or "Leaving" can ever
     * arrive here — the server drops Left and Archived people from the hierarchy entirely — so the
     * chart only has to render the Leaving badge.
     */
    lifecycleState?: 'Active' | 'Leaving';
    /** Last working day. Present only when leaving. */
    exitDate?: string;
}

export async function getHierarchy() {
    const response = await request.get<Result<EmployeeHierarchyView[]>>("OrganizationalStructure/GetHierarchy");
    return response.data;
}

export async function getHierarchyByCompany(companyId: number) {
    const response = await request.get<Result<EmployeeHierarchyView[]>>(`OrganizationalStructure/GetHierarchyByCompany/${companyId}`);
    return response.data;
}
